import { request } from "@/utils/request";

export const initList = () => {
  return request.get("/search/initList");
};

export const cofinitList = () => {
  return request.get("/search/cofInitList");
};

export const search = ({ keyword, page, limit }) => {
  return request.post(
    `/search/search?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const searchTfTarget = ({ keyword, page, limit }) => {
  return request.post(
    `/target/search?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const filter = ({ page, limit, data }) => {
  return request.post(`/search/filter?page=${page}&limit=${limit}`, data);
};

export const filterTfTarget = ({ page, limit, data }) => {
  return request.post(`/target/filter?page=${page}&limit=${limit}`, data);
};

export const getPopularWords = () => {
  return request.get(`/search/getPopularWords`);
};

export const exportFilteredData = ({
  species,
  tfName,
  tfType,
  type,
  ensemblId,
  geneId,
  transcriptId,
  proteinId,
  uniprotId,
  sourceId,
}) => {
  return request.post(`/search/exportFilteredData`, {
    species,
    tfName,
    tfType,
    type,
    ensemblId,
    geneId,
    transcriptId,
    proteinId,
    uniprotId,
    sourceId,
  });
};

export const exportTfTargetData = ({
  species,
  tfName,
  tfType,
  type,
  ensemblId,
  geneId,
  transcriptId,
  proteinId,
  uniprotId,
  sourceId,
}) => {
  return request.post(`/target/exportFilteredData`, {
    species,
    tfName,
    tfType,
    type,
    ensemblId,
    geneId,
    transcriptId,
    proteinId,
    uniprotId,
    sourceId,
  });
};

export const exportSearchResults = (keyword, page, limit) => {
  return request.post(
    `/search/exportSearchResults?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const exportTfTarget = (keyword, page, limit) => {
  return request.post(
    `/target/exportSearchResults?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const searchTfCof = ({ keyword, page, limit }) => {
  return request.post(
    `/search/searchTfCof?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const filterTfCof = ({ page, limit, data }) => {
  return request.post(`/search/filterTfCof?page=${page}&limit=${limit}`, data);
};

export const tfCofExportSearchResults = (keyword, page, limit) => {
  return request.post(
    `/search/tfCofExportSearchResults?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

export const exportTfCofFilteredData = ({
  tfName,
  tfCofName,
  species,
  externalId,
  pubchemCid,
  pubchemSid,
}) => {
  return request.post(`/search/exportTfCofFilteredData`, {
    tfName,
    tfCofName,
    species,
    externalId,
    pubchemCid,
    pubchemSid,
  });
};

// 分页查询指定TF相关联的TF Target
export const listRelativeTfTarget = ({ tfId, page, limit }) => {
  return request.get(
    `/tf/listRelativeTfTarget?tfId=${tfId}&page=${page}&limit=${limit}`
  );
};

// 分页查询指定Target相关联的TF Target
export const listRelativeTf = ({ targetId, page, limit }) => {
  return request.get(
    `/target/listRelativeTf?targetId=${targetId}&page=${page}&limit=${limit}`
  );
};
